export const groupBy = (array, keyOrIterator) => {
  return array.reduce((accumulator, item) => {
    const keyValue =
      typeof keyOrIterator === 'function' ? keyOrIterator(item) : item[keyOrIterator];
    if (!accumulator[keyValue]) {
      accumulator[keyValue] = [];
    }
    accumulator[keyValue].push(item);
    return accumulator;
  }, {});
};
